import { render, staticRenderFns } from "./NewTraining.vue?vue&type=template&id=c09072a4"
import script from "./NewTraining.vue?vue&type=script&lang=js"
export * from "./NewTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports